import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import DeviceService from '../../services/Zlink Device Service/DeviceService';

const initialState = [];
export const addDevice = createAsyncThunk('device/reboot', async (payload) => {
    const res = await DeviceService.addDevice(payload);
    return res.data;
});
export const listOfDevice = createAsyncThunk('device/list', async (payload) => {
    const res = await DeviceService.listOfDevice(payload);
    return res.data;
});
export const updateDevice = createAsyncThunk('device/update', async (payload) => {
    const res = await DeviceService.updateDevice(payload);
    return res.data;
});

export const rebootDevice = createAsyncThunk('device/reboot', async (payload) => {
    const res = await DeviceService.rebootDevice(payload);
    return res.data;
});

export const deleteDevice = createAsyncThunk('device/reboot', async (payload) => {
    const res = await DeviceService.deleteDevice(payload);
    return res.data;
});

const DeviceSlice = createSlice({
    name: 'device',
    initialState,
    extraReducers: {

    }
})


const { reducer } = DeviceSlice;
export default reducer;